/**
 * THIS EXISTS ONLY FOR LEGACY SUPPORT!
 *
 * All calls to relatedProducts should be removed and/or replaced with smartModules
 */

const relatedProducts = () => {
  console.error('LEGACY RELATED PRODUCTS CALL.');
};

export default relatedProducts;
